// @flow
import React, { Component } from 'react';
import DidItSuggestionCreateButton from 'app/common/react/components/do/aggregated-pins/did-it/DidItProfileFeed/DidItSuggestionCreateButton';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import { Box, Image, Mask, Text } from 'gestalt';

const PIN_IMAGE_SIZE = '136x136';

type Props = {
  loggedInUser: {
    id: string,
    username: string,
  },
  pin: {
    id: string,
    title: string,
    images: {
      '136x136': {
        url: string,
        width: number,
        height: number,
      },
    },
    rich_metadata?: {
      title: string,
    },
    rich_summary?: {
      display_name: string,
    },
    aggregated_pin_data: {
      id: string,
    },
    description: string,
    dominant_color: string,
  },
};

type State = {
  isDoneByMe: boolean,
};

export default class DidItSuggestionRep extends Component<Props, State> {
  state: State = {
    isDoneByMe: false,
  };

  handleModalStateChanged = (isDoneByMe: boolean) => this.setState({ isDoneByMe });

  render() {
    const { loggedInUser, pin } = this.props;
    const pinURL = `/pin/${pin.id}/`;
    const pinImageURL = pin.images[PIN_IMAGE_SIZE].url;
    const pinHeight = pin.images[PIN_IMAGE_SIZE].height;
    const pinWidth = pin.images[PIN_IMAGE_SIZE].width;
    const pinTitle = (pin.rich_summary && pin.rich_summary.display_name) || pin.description;

    const buttonProps = {
      aggregatedPinDataId: pin.aggregated_pin_data.id,
      isDoneByMe: this.state.isDoneByMe,
      loggedInUser,
      onDoneStateChanged: this.handleModalStateChanged,
      pinId: pin.id,
      pinTitle,
    };

    return (
      <Box display="flex" alignItems="center" justifyContent="between" deprecatedPadding={{ y: 2 }}>
        <Box xs={{ column: 10, display: 'flex' }} alignItems="center">
          <Box xs={{ column: 2 }}>
            <NavigateLink key={pinURL} to={pinURL}>
              <Mask shape="rounded" wash>
                <Image
                  alt={pin.title}
                  color={pin.dominant_color}
                  naturalHeight={pinHeight}
                  naturalWidth={pinWidth}
                  src={pinImageURL}
                  key={pinImageURL}
                />
              </Mask>
            </NavigateLink>
          </Box>
          <Box xs={{ column: 10 }} deprecatedPadding={{ x: 2 }}>
            <NavigateLink key={pinURL} to={pinURL}>
              <Text lgSize="lg" mdSize="md" size="lg" smSize="sm" weight="bold">
                {' '}
                {pinTitle}{' '}
              </Text>
            </NavigateLink>
          </Box>
        </Box>
        <Box xs={{ column: 2 }}>
          <DidItSuggestionCreateButton {...buttonProps} />
        </Box>
      </Box>
    );
  }
}
